import { ReactComponent as Icon } from './filterIcon.svg'
import { theme } from '@ss/meta-core-components'
import React, { CSSProperties } from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
  style?: CSSProperties
}

export const FilterIcon: React.FC<Props> = ({
  ariaLabel = 'filter',
  role = 'icon',
  style,
}) => {
  return (
    <Icon
      style={style}
      aria-label={ariaLabel}
      role={role}
      data-cy={'filter-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
